<app-card
  [className]="'card--summary'"
  *ngIf="project().ratingThemes.length > 0 && !hide()"
  [language]="project().language"
  [project]="project()"
  [type]="CardType.RATING"
>
</app-card>

@for(survey of project().activeSurveys; track survey.id){
<app-card
  [className]="'card--summary'"
  *ngIf="!hide()"
  [survey]="survey"
  [project]="project()"
  [language]="project().language"
  [type]="CardType.SURVEY"
>
</app-card>
} @if (project().activeSurveys.length === 0 && project().ratingThemes.length === 0)
{
<app-state-notice
  [iconPath]="'/assets/illustrations/feedback_no_items.svg'"
  [title]="'project.tab.participate' | translate"
  [desc]="'participate.empty.desc' | translate"
></app-state-notice>
}
